// =============================================================================
// GiftCardDetailScreen — /cadeaubon/:code, one physical gift card.
// =============================================================================
import { useCallback, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { formatError } from '../lib/errors';
import { fetchGiftCardDetail, normalizeGiftCode, type GiftCardDetail } from '../lib/giftcard';
import { GiftCardView } from '../components/GiftCardView';
import { GiftCardLoadAction } from '../components/GiftCardLoadAction';

export function GiftCardDetailScreen() {
  const { code: rawCode } = useParams<{ code: string }>();
  const code = normalizeGiftCode(rawCode ?? '');
  const [detail, setDetail] = useState<GiftCardDetail | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    if (!code) return;
    setError(null);
    try {
      const d = await fetchGiftCardDetail(code);
      if (!d) setError('Kaart niet gevonden.');
      setDetail(d);
    } catch (e) {
      setError(formatError(e));
    } finally {
      setLoading(false);
    }
  }, [code]);

  useEffect(() => {
    setLoading(true);
    void load();
  }, [load]);

  if (loading) return <div className="screen">Laden…</div>;
  if (error || !detail) {
    return (
      <div className="screen">
        <Link to="/cadeaubonnen" className="back-link">← Cadeaubonnen</Link>
        <div className="error-card">{error ?? 'Niet gevonden'}</div>
      </div>
    );
  }

  return (
    <div className="screen detail-screen voucher-detail-screen">
      <Link to="/cadeaubonnen" className="back-link">← Cadeaubonnen</Link>
      <GiftCardView
        detail={detail}
        onChanged={() => void load()}
        loadAction={<GiftCardLoadAction card={detail.card} onSettled={() => void load()} />}
      />
    </div>
  );
}
